export default __webpack_public_path__ + "static/warning-4a74143cf8c0df027b4354e3d579649e.svg";